import { render, staticRenderFns } from "./MyScorecard.vue?vue&type=template&id=f6d3d9aa&"
import script from "./MyScorecard.vue?vue&type=script&lang=js&"
export * from "./MyScorecard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports